import {Injectable} from '@angular/core';
import {BaseApiService} from '../common/services/api/base-api.service';

/** What the server tells a signed-out visitor about a company sign-in. */
export interface SsoProviderInfo {
  /** Firebase provider id, `saml.acme` or `oidc.acme`. */
  providerId: string;
  type: 'saml' | 'oidc';
  /** The organisation's name, for "Sign in with Acme Ltd". */
  name: string;
}

/** The error code the lookup answers with when no organisation uses the id. */
export const SSO_PROVIDER_NOT_FOUND = 'sso_provider_not_found';

/** Firebase provider ids look like `saml.acme` or `oidc.acme` (same rule as the server). */
export const SSO_PROVIDER_ID_PATTERN = /^(saml|oidc)\.[A-Za-z0-9_-]+$/;

/**
 * Company sign-in (SAML / OIDC) lookups for the sign-in page.
 *
 * The page used to know exactly one provider, hard-coded in AuthService, so
 * no other organisation's sign-in link could ever work. The server now says
 * whether a provider id belongs to an active organisation and what to call it.
 * The route needs no token: whoever asks cannot sign in yet.
 */
@Injectable({
  providedIn: 'root',
})
export class SsoApiService extends BaseApiService {

  getProvider(providerId: string): Promise<SsoProviderInfo> {
    return this.get<SsoProviderInfo>(`/auth/sso/provider/${encodeURIComponent(providerId)}`);
  }
}
